

// Vendor
// jQuery
//=require ./vendor/jquery.min.js
// Branches
//=require ./modules/branch-bar.js
// Slick
//=require ./vendor/slick.min.js
// Parallax
//=require ./vendor/TweenMax.min.js
//=require ./vendor/ScrollMagic/minified/ScrollMagic.min.js
//=require ./vendor/ScrollMagic/minified/plugins/animation.gsap.min.js
//=require ./vendor/ScrollMagic/minified/plugins/debug.addIndicators.min.js

// Custom
//=require ./modules/main-custom.js
//=require ./modules/contact-us-form.js
//=require ./modules/TermsCheckbox.js

// Bootstrap 
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/transition.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/alert.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/button.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/carousel.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/collapse.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/dropdown.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/modal.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/tab.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/affix.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/scrollspy.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/tooltip.js
//= require ../../bower_components/bootstrap-sass/assets/javascripts/bootstrap/popover.js